import { t } from '@lingui/macro';
import { AlertDialog } from 'components/dialogs/AlertDialog';
import React, { useEffect, useState } from 'react';
import { Input } from 'components/Form/Input';
import { graphql, useFragment, useMutation } from 'utils/graphClient';
import { OverlayProps } from 'components/TaskOverlay';
import { TodoDueDateModal_scheduleTodo_Mutation } from './__generated__/TodoDueDateModal_scheduleTodo_Mutation.graphql';
import { TodoDueDateModal_todo$key } from './__generated__/TodoDueDateModal_todo.graphql';

const fragment = graphql`
  fragment TodoDueDateModal_todo on Todo {
    id
    dueDate
  }
`;

const scheduleTodoMutation = graphql`
  mutation TodoDueDateModal_scheduleTodo_Mutation($id: ID!, $date: Date) {
    scheduleTodo(input: { id: $id, date: $date }) {
      todoUpdated {
        ...TodoDueDate_todo
      }
    }
  }
`;

interface TodoDueDateModal extends OverlayProps {
  todo: TodoDueDateModal_todo$key;
}

export const TodoDueDateModal = ({
  todo,
  isOpen,
  onClose,
}: TodoDueDateModal) => {
  const { id, dueDate: initialDueDate } = useFragment(fragment, todo);

  const [dueDate, setDueDate] = useState(initialDueDate);
  const isDirty = initialDueDate !== dueDate;

  const [scheduleTodo, isLoading] =
    useMutation<TodoDueDateModal_scheduleTodo_Mutation>(scheduleTodoMutation);

  function handleActionClick() {
    scheduleTodo({ variables: { id, date: dueDate || null } });
    onClose();
  }

  useEffect(() => {
    setDueDate(initialDueDate);
  }, [isOpen, initialDueDate]);

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      title={t`Due date`}
      cancelButton={{ title: t`Cancel`, onClick: onClose }}
      actionButton={{
        title: t`Save`,
        onClick: handleActionClick,
        isDisabled: !isDirty,
        isLoading,
      }}
    >
      <Input
        type="date"
        label={t`Due date`}
        value={dueDate || undefined}
        onChange={({ target: { value } }) => {
          setDueDate(value);
        }}
      />
    </AlertDialog>
  );
};
